import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Pending Batch Activities")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6 mt-5"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Note: Certified Trainees data will be shown", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Pending Batch Activities", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "card p-3 mb-5 position-relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col bg-light-success d-flex align-items-center px-6 py-8 rounded-2 me-4" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user fs-3x text-success" })
        ]),
        /*#__PURE__*/_createElementVNode("h4", { class: "col mt-5" }, "167"),
        /*#__PURE__*/_createElementVNode("a", {
          href: "/assessor",
          class: "text-success fw-bold fs-6 mt-2"
        }, "ENROLLMENT PENDING")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col bg-light-danger d-flex align-items-center px-6 py-8 rounded-2 me-4" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3x text-danger" })
        ]),
        /*#__PURE__*/_createElementVNode("h4", { class: "col mt-5" }, "7,499"),
        /*#__PURE__*/_createElementVNode("a", {
          href: "/trainer",
          class: "text-danger fw-bold fs-6 mt-2"
        }, "ATTENDANCE PENDING ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col bg-light-success d-flex align-items-center px-6 py-8 rounded-2 me-4" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
        ]),
        /*#__PURE__*/_createElementVNode("h4", { class: "col mt-5" }, "166,352"),
        /*#__PURE__*/_createElementVNode("a", {
          href: "/assessor",
          class: "text-success fw-bold fs-6 mt-2"
        }, "ASSESSMENT PENDING ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col bg-light-primary d-flex align-items-center px-6 py-8 rounded-2 me-4" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2 col-md-3 mr-3" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-3x text-primary" })
        ]),
        /*#__PURE__*/_createElementVNode("h4", { class: "col mt-5" }, "78"),
        /*#__PURE__*/_createElementVNode("a", {
          href: "/trainee",
          class: "text-primary fw-bold fs-7 mt-2"
        }, "CERTIFICATION PENDING ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col bg-light-info d-flex align-items-center px-6 py-8 rounded-2" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-info d-block my-2 col-md-3 mr-3" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user fs-3x text-info" })
        ]),
        /*#__PURE__*/_createElementVNode("h4", { class: "col mt-5" }, "78"),
        /*#__PURE__*/_createElementVNode("a", {
          href: "/trainee",
          class: "text-info fw-bold fs-7 mt-2"
        }, "EMPLOYMENT (> 30)")
      ])
    ])
  ])
], -1)
const _hoisted_17 = { class: "card mb-5 mb-xl-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1)
const _hoisted_19 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_20 = { class: "collapse show" }
const _hoisted_21 = { class: "card-body border-top p-6" }
const _hoisted_22 = {
  class: "current",
  "data-kt-stepper-element": "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.courseNotice())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Tranche-1",
                          value: "1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-2",
                          value: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-3",
                          value: "3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: "Tranche-4",
                          value: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tranche-4")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                ((_ctx.showCourseNotice == true) & (_ctx.batch.tranche_id != 4))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                  : _createCommentVNode("", true),
                ((_ctx.showCourseNotice == true) & (_ctx.batch.tranche_id != 4))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _hoisted_16,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_Datatable, {
                                    "table-data": _ctx.tableData,
                                    "table-header": _ctx.tableHeader,
                                    "enable-items-per-page-dropdown": true
                                  }, {
                                    "cell-sl": _withCtx(({ row }) => [
                                      _createTextVNode(_toDisplayString(row.id), 1)
                                    ]),
                                    "cell-code": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry.code), 1)
                                    ]),
                                    "cell-bg": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry.bg), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["table-data", "table-header"])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}